/**
 * PageContainer — the constrained-width page shape.
 *
 * The app has two page shapes. A full-bleed page (Review) fills the main
 * area and lays itself out. Every other page leaves whitespace at the
 * sides, and this is that shape: one max width and one inset for all of
 * them, so Models, Evals, the Dashboard and Settings read as one product
 * instead of each picking its own. max-w-6xl is the floor set by the
 * widest content — the 90-day uptime wall is ~1000px and clipped at 5xl.
 *
 * `className` carries the page's vertical rhythm (space-y-*) or a flex
 * row (SettingsFrame). Never a width or padding override: a page that
 * needs a different width is the full-bleed shape, not a third one.
 */

import { cn } from '@/lib/utils'

interface PageContainerProps {
  className?: string
  children: React.ReactNode
}

export function PageContainer({ className, children }: PageContainerProps): React.JSX.Element {
  return <div className={cn('mx-auto max-w-6xl p-6 pb-16', className)}>{children}</div>
}
